import { useContext, useRef, useState } from "react";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import EmailCodeVerification from "../EmailCodeVerification";
import { useNavigate } from "react-router-dom";
import { GoogleMapsContext } from "../../context/GoogleMapsProvider";
import GoogleMapView from "../GoogleMapView";
import Cgu from "../Cgu";
import GoogleAddressSearch from "../GoogleAddressSearch";

export default function InscriptionClient({ onClose, onSwitch, formDataProjet = null }) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const [photoPreview, setPhotoPreview] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const photoInputRef = useRef(null);
    const logoInputRef = useRef(null);
    const [inscriptionSuccess, setInscriptionSuccess] = useState(false);
    const [projectSuccess, setProjectSuccess] = useState(null); // null = pas encore testé, true = succès, false = échec
    const navigate = useNavigate();
    const { isLoaded } = useContext(GoogleMapsContext);
    const [cguAccepted, setCguAccepted] = useState(false);

    const [formData, setFormData] = useState({
        nom: "",
        prenom: "",
        email: "",
        password: "",
        passwordRepeat: "",
        token: "",
        photoProfil: "",
        type: "particulier",
        billingAddress: "",
        billingPostalCode: "",
        billingCity: "",
        billingCountry: "fr",
        billingLat: null,
        billingLng: null,
        phoneNumber: "",
        logoEntreprise: "",
        raisonSociale: "",
        siret: "",
        numTva: "",
        nomAssociation: "",
        rna: "",
        nomOrganisation: "",
        typeOrganisation: "",
        numEnregistrement: "",

    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handlePlaceSelect = (place) => {
        // Extraction des composants d'adresse
        const components = place.address_components || [];
        let streetNumber = "", route = "", postal = "", city = "";

        components.forEach((c) => {
            if (c.types.includes("street_number")) streetNumber = c.long_name;
            if (c.types.includes("route")) route = c.long_name;
            if (c.types.includes("postal_code")) postal = c.long_name;
            if (c.types.includes("locality")) city = c.long_name;
            if (!city && c.types.includes("administrative_area_level_2")) city = c.long_name;
        });

        const formattedAddress = [streetNumber, route].filter(Boolean).join(" ") + ", " + postal + " " + city;

        // Fonction pour mettre à jour le formData
        const updateFormData = (lat, lng) => {
            setFormData((prev) => ({
                ...prev,
                billingAddress: [streetNumber, route].filter(Boolean).join(" "),
                billingPostalCode: postal,
                billingCity: city,
                billingLat: lat,
                billingLng: lng,
            }));

            validateField("billingAddress", [streetNumber, route].filter(Boolean).join(" "));
            validateField("billingPostalCode", postal);
            validateField("billingCity", city);
        };

        // Vérifie si place.geometry existe
        if (place.geometry && place.geometry.location) {
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            updateFormData(lat, lng);
        } else {
            // Sinon, utiliser Geocoder pour obtenir lat/lng à partir de l'adresse
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address: formattedAddress }, (results, status) => {
                if (status === "OK" && results[0]) {
                    const lat = results[0].geometry.location.lat();
                    const lng = results[0].geometry.location.lng();
                    updateFormData(lat, lng);
                } else {
                    console.error("Impossible de récupérer les coordonnées :", status, place);
                    updateFormData(null, null); // vide lat/lng si échec
                }
            });
        }
    };

    const [step, setStep] = useState(1);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordRepeat, setShowPasswordRepeat] = useState(false);
    const [errors, setErrors] = useState({});

    const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

    const validateField = (name, value) => {
        let fieldErrors = { ...errors };

        switch (name) {
            case "email":
                if (!value) {
                    fieldErrors.email = "L'email est requis";
                } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                    fieldErrors.email = "L'adresse email est invalide.";
                } else {
                    // Si format valide, on vérifie côté API
                    delete fieldErrors.email;

                    fetch(`${apiUrl}/api/register/checkMail?email=${encodeURIComponent(value)}`)
                        .then((res) => res.json())
                        .then((data) => {
                            if (data.exists) {
                                // Si ton API renvoie { exists: true }
                                setErrors((prev) => ({
                                    ...prev,
                                    email: "Cet email est déjà utilisé."
                                }));
                            } else {
                                setErrors((prev) => {
                                    const { email, ...rest } = prev;
                                    return rest; // supprime l'erreur email
                                });
                            }
                        })
                        .catch((err) => {
                            console.error("Erreur vérification email:", err);
                        });
                }
                break;


            case "password":
                if (!value) {
                    fieldErrors.password = "Le mot de passe est requis";
                } else if (!passwordRegex.test(value)) {
                    fieldErrors.password = (
                        <ul className="password-rules">
                            <li className={value.length >= 8 ? "ok" : "error"}>
                                {value.length >= 8 ? "✅" : "❌"} 8 caractères minimum
                            </li>
                            <li className={/[A-Z]/.test(value) ? "ok" : "error"}>
                                {/[A-Z]/.test(value) ? "✅" : "❌"} 1 majuscule
                            </li>
                            <li className={/[a-z]/.test(value) ? "ok" : "error"}>
                                {/[a-z]/.test(value) ? "✅" : "❌"} 1 minuscule
                            </li>
                            <li className={/\d/.test(value) ? "ok" : "error"}>
                                {/\d/.test(value) ? "✅" : "❌"} 1 chiffre
                            </li>
                            <li
                                className={
                                    /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value)
                                        ? "ok"
                                        : "error"
                                }
                            >
                                {/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value)
                                    ? "✅"
                                    : "❌"}{" "}
                                1 caractère spécial
                            </li>
                        </ul>
                    );
                } else {
                    delete fieldErrors.password;
                }
                break;

            case "passwordRepeat":
                if (formData.password !== value) {
                    fieldErrors.passwordRepeat = "Les mots de passes ne sont pas identiques";
                } else {
                    delete fieldErrors.passwordRepeat;
                }
                break;

            case "nom":
                if (!value || value.length < 2) {
                    fieldErrors.nom = "Le nom doit contenir au moins 2 caractères";
                } else {
                    delete fieldErrors.nom;
                }
                break;

            case "prenom":
                if (!value || value.length < 2) {
                    fieldErrors.prenom = "Le prénom doit contenir au moins 2 caractères";
                } else {
                    delete fieldErrors.prenom;
                }
                break;

            case "billingAddress":
                if (!value || value.length < 5) {
                    fieldErrors.billingAddress = "L'adresse doit contenir au moins 5 caractères";
                } else {
                    delete fieldErrors.billingAddress;
                }
                break;

            case "billingPostalCode":
                if (!/^\d{5}$/.test(value)) {
                    fieldErrors.billingPostalCode = "Le code postal doit contenir exactement 5 chiffres";
                } else {
                    delete fieldErrors.billingPostalCode;
                }
                break;

            case "billingCity":
                if (!value || value.length < 2) {
                    fieldErrors.billingCity = "La ville doit contenir au moins 2 caractères";
                } else {
                    delete fieldErrors.billingCity;
                }
                break;

            case "phoneNumber":
                if (!/^\d{10}$/.test(value)) {
                    fieldErrors.phoneNumber = "Le numéro doit contenir exactement 10 chiffres";
                } else {
                    delete fieldErrors.phoneNumber;
                }
                break;

            default:
                break;
        }

        setErrors(fieldErrors);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        validateField(name, value);
    };

    // --- Gestion fichiers ---
    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (file) {
            if (type === "photoProfil") {
                setFormData((prev) => ({ ...prev, photoProfil: file }));
                setPhotoPreview(URL.createObjectURL(file));
            } else if (type === "logoEntreprise") {
                setFormData((prev) => ({ ...prev, logoEntreprise: file }));
                setLogoPreview(URL.createObjectURL(file));
            }
        }
    };

    const handleRemoveFile = (type) => {
        if (type === "photoProfil") {
            if (photoPreview) URL.revokeObjectURL(photoPreview);
            setFormData((prev) => ({ ...prev, photoProfil: null }));
            setPhotoPreview(null);
            if (photoInputRef.current) photoInputRef.current.value = "";
        } else if (type === "logoEntreprise") {
            if (logoPreview) URL.revokeObjectURL(logoPreview);
            setFormData((prev) => ({ ...prev, logoEntreprise: null }));
            setLogoPreview(null);
            if (logoInputRef.current) logoInputRef.current.value = "";
        }
    };

    // --- handleSubmit modifié ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        
        setIsSubmitting(true);

        if (Object.keys(errors).length > 0) {
            alert("Veuillez corriger les erreurs avant de soumettre.");
            return;
        }

        try {
            const form = new FormData();

            Object.keys(formData).forEach((key) => {
                if (formData[key] && typeof formData[key] !== "object") {
                    form.append(key, formData[key]);
                }
            });

            if (formData.photoProfil) {
                form.append("photoProfil", formData.photoProfil);
            }
            if (formData.logoEntreprise) {
                form.append("logo", formData.logoEntreprise);
            }

            const response = await fetch(`${apiUrl}/api/register/client`, {
                method: "POST",
                body: form,
            });

            if (!response.ok) {
                const errorData = await response.json();
                alert(errorData.message || "Une erreur est survenue lors de l’inscription.");
                return;
            }

            const data = await response.json();
            console.log("✅ Inscription réussie :", data);

            // Dans handleSubmit après l’inscription réussie :
            if (formDataProjet) {
                try {
                    const projectForm = new FormData();

                    // Champs texte
                    Object.entries(formDataProjet).forEach(([key, value]) => {
                        if (key !== "images" && key !== "pdfs" && key !== "video") {
                            projectForm.append(key, value);
                        }
                    });

                    // Images
                    if (formDataProjet.images) {
                        formDataProjet.images.forEach((img) => {
                            projectForm.append("images[]", img.file);
                        });
                    }

                    // PDFs
                    if (formDataProjet.pdfs) {
                        formDataProjet.pdfs.forEach((pdf) => {
                            projectForm.append("pdfs[]", pdf);
                        });
                    }

                    // Vidéo
                    if (formDataProjet.video) {
                        projectForm.append("video", formDataProjet.video.file);
                    }
                    if (formDataProjet.besoins) {
                        formDataProjet.besoins.forEach((b, i) => {
                            projectForm.append(`besoins[${i}][metierId]`, b.metierId);
                            projectForm.append(`besoins[${i}][nbPersonnes]`, b.nbPersonnes);
                        });
                    }



                    const projectRes = await fetch(`${apiUrl}/api/projects`, {
                        method: "POST",
                        headers: { Authorization: `Bearer ${data.token}` },
                        body: projectForm,
                    });

                    if (!projectRes.ok) {
                        const err = await projectRes.json();
                        console.error("❌ Erreur ajout projet :", err);
                        setProjectSuccess(false);
                    } else {
                        console.log("✅ Projet ajouté automatiquement après inscription !");
                        setProjectSuccess(true);
                    }
                } catch (err) {
                    console.error("Erreur envoi projet après inscription :", err);
                    setProjectSuccess(false);
                }
            }

            setInscriptionSuccess(true);

        } catch (error) {
            console.error("Erreur lors de l’inscription :", error);
            alert("Impossible de se connecter au serveur. Réessayez plus tard.");
        }
        setIsSubmitting(false);
    };

    const isStep1Valid = !errors.email && !errors.password && !errors.passwordRepeat && formData.email && formData.password && formData.passwordRepeat;
    const isStep2Valid =
        !errors.nom &&
        !errors.prenom &&
        !errors.billingAddress &&
        !errors.billingPostalCode &&
        !errors.billingCity &&
        !errors.phoneNumber &&
        formData.nom &&
        formData.prenom &&
        formData.billingAddress &&
        formData.billingPostalCode &&
        formData.billingCity &&
        formData.billingLat &&
        formData.billingLng &&
        formData.phoneNumber;

    return (
        <div className="inscriptionModalOverlay">
            <div className="inscriptionModal">
                <button className="inscriptionModalClose" onClick={onClose}>
                    ×
                </button>
                <h2>INSCRIPTION CLIENT</h2>



                {
                    !inscriptionSuccess && (
                        <>
                            {step === 0 && (
                                <div>
                                    <h3>Bienvenue sur INTERESEAUX</h3>
                                    <p>

                                        <strong style={{color:"red"}}>Vous êtes ici pour créer un compte client</strong> : cet espace est réservé aux personnes qui
                                        souhaitent publier des projets, comparer des offres et trouver des prestataires pour les réaliser.
                                    </p>

                                    <p style={{ marginTop: "15px" }}>
                                        <strong>Vous n’êtes PAS au bon endroit si :</strong>
                                    </p>

                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            ⚠️ <strong>Vous êtes prestataire</strong> et vous cherchez des missions ou des opportunités.
                                            Dans ce cas, rendez-vous dans l’espace prestataire en cliquant
                                            <strong onClick={() => navigate("/espace-prestataire")} style={{ cursor: "pointer" }}> ici</strong>.
                                        </li>
                                        <li style={{ marginTop: "10px" }}>
                                            ⚠️ <strong>Vous êtes un donneur d’ordres (grande entreprise)</strong> et souhaitez publier des appels d’offres importants.
                                            Accédez à l’espace dédié en cliquant
                                            <strong onClick={() => navigate("/espace-donneur-ordre")} style={{ cursor: "pointer" }}> ici</strong>.
                                        </li>
                                    </ul>

                                    <button className="btn-primary" onClick={() => setStep(1)} style={{ marginTop: "15px" }}>
                                        CONTINUER
                                    </button>
                                </div>
                            )}
                            <form autoComplete="off" onSubmit={handleSubmit}>
                                {/* --- Étape 1 --- */}
                                {step === 1 && (
                                    <>
                                        <h3>Vos identifiants de connexion</h3>

                                        {/* Email */}
                                        <div className="inscriptionClientModal-input-form">
                                            <label>Email</label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                placeholder="Entrez votre email"
                                                onChange={handleChange}
                                                required
                                            />
                                            {errors.email && <p className="error-text">{errors.email}</p>}
                                        </div>

                                        {/* Mot de passe */}
                                        <div className="inscriptionClientModal-input-form">
                                            <label htmlFor="password">Choisissez un mot de passe</label>
                                            <div className="password-wrapper">
                                                <input
                                                    id="password"
                                                    name="password"
                                                    type={showPassword ? "text" : "password"}
                                                    value={formData.password}
                                                    placeholder="Votre mot de passe"
                                                    onChange={handleChange}
                                                    required
                                                    autoComplete="new-password"
                                                />
                                                <span
                                                    className="togglePassword"
                                                    aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                                                    onClick={() => setShowPassword((v) => !v)}
                                                >
                                                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                                </span>
                                            </div>
                                            {errors.password && <>{errors.password}</>}
                                        </div>

                                        {/* Répéter le mot de passe */}
                                        <div className="inscriptionClientModal-input-form">
                                            <label htmlFor="passwordRepeat">Répétez votre mot de passe</label>
                                            <div className="password-wrapper">
                                                <input
                                                    id="passwordRepeat"
                                                    name="passwordRepeat"
                                                    type={showPasswordRepeat ? "text" : "password"}
                                                    value={formData.passwordRepeat}
                                                    placeholder="Répétez votre mot de passe"
                                                    onChange={handleChange}
                                                    required
                                                    autoComplete="new-password"
                                                />
                                                <span
                                                    className="togglePassword"
                                                    aria-label={showPasswordRepeat ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                                                    onClick={() => setShowPasswordRepeat((v) => !v)}
                                                >
                                                    <FontAwesomeIcon icon={showPasswordRepeat ? faEyeSlash : faEye} />
                                                </span>
                                            </div>
                                            {errors.passwordRepeat && <p className="error-text">{errors.passwordRepeat}</p>}
                                        </div>

                                        {/* Bouton suivant */}
                                        <div className="inscriptionClientModal-input-form">
                                            <button type="button" onClick={() => setStep(2)} disabled={!isStep1Valid}>
                                                Suivant
                                            </button>
                                        </div>
                                        <p className="modal-switch">
                                            Déjà inscrit ?{" "}
                                            <span onClick={onSwitch}>
                                                Connectez-vous
                                            </span>
                                        </p>
                                    </>
                                )}
                                {step === 2 && (
                                    <EmailCodeVerification
                                        formData={formData}
                                        onVerified={(token) => {
                                            setFormData(prev => ({
                                                ...prev,
                                                token: token
                                            }));
                                            setTimeout(() => console.log("State réel :", token), 500);
                                            setStep(3);
                                        }}
                                    />
                                )}


                                {/* --- Étape 3 --- */}
                                {step === 3 && (
                                    <>
                                        <h3>Vos informations personnelles</h3>
                                        <div className="inscriptionClientModal-input-form">
                                            <label>Quel type de client êtes vous ?</label>
                                            <div className="radio-group">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="type"
                                                        value="particulier"
                                                        checked={formData.type === "particulier"}
                                                        onChange={handleChange}
                                                    />
                                                    Particulier
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="type"
                                                        value="entreprise"
                                                        checked={formData.type === "entreprise"}
                                                        onChange={handleChange}
                                                    />
                                                    Professionnel
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="type"
                                                        value="association"
                                                        checked={formData.type === "association"}
                                                        onChange={handleChange}
                                                    />
                                                    Association
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="type"
                                                        value="autre"
                                                        checked={formData.type === "autre"}
                                                        onChange={handleChange}
                                                    />
                                                    Autre
                                                </label>
                                            </div>
                                        </div>

                                        <div className="inscriptionClientModal-input-form">
                                            <label>Nom</label>
                                            <input autoComplete="new-password" type="text" name="nom" value={formData.nom} onChange={handleChange} required />
                                            {errors.nom && <p className="error-text">{errors.nom}</p>}
                                        </div>

                                        <div className="inscriptionClientModal-input-form">
                                            <label>Prénom</label>
                                            <input autoComplete="new-password"
                                                type="text" name="prenom" value={formData.prenom} onChange={handleChange} required />
                                            {errors.prenom && <p className="error-text">{errors.prenom}</p>}
                                        </div>
                                        <div className="inscriptionPrestataireModal-input-form">

                                            {isLoaded && !formData.billingAddress && !formData.billingPostalCode && !formData.billingCity && !formData.billingLat && !formData.billingLng && (
                                                <>
                                                    <label>Rechercher mon adresse</label>
                                                    <GoogleAddressSearch
                                                        value=""
                                                        onChange={(inputValue) => {
                                                            // Si l'utilisateur vide le champ, on supprime les infos d'adresse
                                                            if (!inputValue) {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    billingAddress: "",
                                                                    billingPostalCode: "",
                                                                    billingCity: "",
                                                                    billingLat: null,
                                                                    billingLng: null
                                                                }));
                                                            }
                                                        }}
                                                        onSelect={handlePlaceSelect}
                                                    />

                                                </>
                                            )}
                                            {formData.billingLat && formData.billingLng && (
                                                <>
                                                    <div>
                                                        <h3>Adresse</h3>
                                                        <p>{formData.billingAddress}</p>
                                                        <p>{formData.billingPostalCode} {formData.billingCity}</p>
                                                        <button className="btn-primary" onClick={(e) => {
                                                            e.preventDefault();
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                billingAddress: "",
                                                                billingCity: "",
                                                                billingPostalCode: "",
                                                                billingLat: null,
                                                                billingLng: null
                                                            }));
                                                        }}>MODIFIER</button>
                                                    </div>
                                                    <GoogleMapView origin={{ lat: formData.billingLat, lng: formData.billingLng }} />

                                                </>
                                            )}
                                        </div>

                                        <div className="inscriptionClientModal-input-form">
                                            <label htmlFor="phoneNumber">N° de téléphone</label>
                                            <input autoComplete="new-password" type="text" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required />
                                            {errors.phoneNumber && <p className="error-text">{errors.phoneNumber}</p>}
                                        </div>
                                        <div className="inscriptionClientModal-input-form">
                                            <label>Photo de profil (optionnelle)</label>
                                            <input ref={photoInputRef} type="file" accept="image/*" onChange={(e) => handleFileChange(e, "photoProfil")} />
                                            {photoPreview && (
                                                <div style={{ width: "fit-content", margin: "auto" }}>
                                                    <img src={photoPreview} alt="Prévisualisation" style={{ width: "120px", height: "120px", borderRadius: "50%", objectFit: "cover" }} />
                                                    <button type="button" onClick={() => handleRemoveFile("photoProfil")} style={{ display: "block", margin: "auto", marginTop: "5px", background: "red", color: "white", border: "none", borderRadius: "5px", padding: "5px 10px", cursor: "pointer" }}>Supprimer</button>
                                                </div>
                                            )}
                                        </div>
                                        <div className="inscriptionClientModal-actions">
                                            <button type="button" onClick={() => setStep(1)}>
                                                Précédent
                                            </button>
                                            {formData.type === "particulier" ? (
                                                <button
                                                    type="button"
                                                    disabled={!isStep2Valid}
                                                    onClick={() => setStep(5)}
                                                >
                                                    Suivant
                                                </button>
                                            ) : (
                                                <button
                                                    type="button"
                                                    disabled={!isStep2Valid}
                                                    onClick={() => setStep(4)}
                                                >
                                                    Suivant
                                                </button>
                                            )}
                                        </div>
                                    </>
                                )}
                                {/* --- Étape 4 --- */}
                                {step === 4 && (
                                    <>
                                        {formData.type === "entreprise" && (
                                            <>
                                                <h3>Informations entreprise</h3>
                                                <div className="inscriptionClientModal-input-form">
                                                    <label>Raison sociale</label>
                                                    <input autoComplete="new-password" type="text" name="raisonSociale" value={formData.raisonSociale || ""} onChange={handleChange} />
                                                </div>
                                                <div className="inscriptionClientModal-input-form">
                                                    <label>N° SIRET</label>
                                                    <input autoComplete="new-password" type="text" name="siret" value={formData.siret || ""} onChange={handleChange} />
                                                </div>
                                                <div className="inscriptionClientModal-input-form">
                                                    <label>N° TVA Intracommunautaire (si assujeti)</label>
                                                    <input autoComplete="new-password" type="text" name="numTva" value={formData.numTva || ""} onChange={handleChange} />
                                                </div>
                                                <div className="inscriptionClientModal-input-form">
                                                    <label>Logo de l'entreprise</label>
                                                    <input ref={logoInputRef} type="file" accept="image/*" onChange={(e) => handleFileChange(e, "logoEntreprise")} />
                                                    {logoPreview && (
                                                        <div style={{ width: "fit-content", margin: "auto" }}>
                                                            <img src={logoPreview} alt="Prévisualisation logo" style={{ width: "150px" }} />
                                                            <button type="button" onClick={() => handleRemoveFile("logoEntreprise")} style={{ display: "block", margin: "auto", marginTop: "5px", background: "red", color: "white", border: "none", borderRadius: "5px", padding: "5px 10px", cursor: "pointer" }}>Supprimer</button>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}

                                        {formData.type === "association" && (
                                            <>
                                                <h3>Informations association</h3>
                                                <div className="inscriptionClientModal-input-form">
                                                    <label>Nom de l'association</label>
                                                    <input autoComplete="new-password" type="text" name="nomAssociation" value={formData.nomAssociation || ""} onChange={handleChange} />
                                                </div>
                                                <div className="inscriptionClientModal-input-form">
                                                    <label>N° RNA</label>
                                                    <input autoComplete="new-password" type="text" name="rna" value={formData.rna || ""} onChange={handleChange} />
                                                </div>

                                            </>
                                        )}

                                        {formData.type === "autre" && (
                                            <>
                                                <h3>Informations supplémentaires</h3>
                                                <div className="inscriptionClientModal-input-form">
                                                    <label>Nom de l'organisation</label>
                                                    <input autoComplete="new-password" type="text" name="nomOrganisation" value={formData.nomOrganisation || ""} onChange={handleChange} />
                                                </div>
                                                <div className="inscriptionClientModal-input-form">
                                                    <label>Type d'organisation</label>
                                                    <input autoComplete="new-password" type="text" name="typeOrganisation" value={formData.typeOrganisation || ""} onChange={handleChange} />
                                                </div>
                                                <div className="inscriptionClientModal-input-form">
                                                    <label>N° d'enregistrement (si applicable)</label>
                                                    <input autoComplete="new-password" type="text" name="numEnregistrement" value={formData.numEnregistrement || ""} onChange={handleChange} />
                                                </div>
                                            </>
                                        )}

                                        <div className="inscriptionClientModal-actions">
                                            <button type="button" onClick={() => setStep(3)}>Précédent</button>
                                            <button type="submit" onClick={() => setStep(5)}>Suivant</button>
                                        </div>


                                    </>
                                )}
                                {
                                    step === 5 && (
                                        <div>
                                            <p style={{ marginBottom: "10px" }}>
                                                Veuillez lire attentivement les conditions générales d'utilisation
                                            </p>

                                            {/* Conteneur scrollable */}
                                            <div
                                                style={{
                                                    maxHeight: "300px",
                                                    overflowY: "auto",
                                                    padding: "15px",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "8px",
                                                    backgroundColor: "#fafafa"
                                                }}
                                            >
                                                <Cgu />
                                            </div>

                                            <div style={{ marginTop: "20px" }}>
                                                <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={cguAccepted}
                                                        onChange={(e) => setCguAccepted(e.target.checked)}
                                                    />
                                                    <span>
                                                        J'ai lu et j'accepte les <strong>Conditions Générales d'Utilisation</strong>.
                                                    </span>
                                                </label>
                                            </div>

                                            <div className="inscriptionClientModal-actions">
                                                <button
                                                    type="button"
                                                    onClick={() => formData.type === "particulier" ? setStep(3) : setStep(4)}
                                                >
                                                    Précédent
                                                </button>

                                                <button
                                                    type="submit"
                                                    disabled={!cguAccepted}
                                                    onClick={handleSubmit}
                                                >
                                                    Valider
                                                </button>
                                            </div>
                                        </div>
                                    )
                                }


                            </form></>
                    )
                }
                {inscriptionSuccess && (
                    <div className="success-container">
                        <h2>🎉 Inscription réussie</h2>
                        <p>
                            Bienvenue sur notre plateforme, votre compte Client INTERESEAUX est créé avec succès.
                        </p>

                        {projectSuccess === true && (
                            <p className="success-text">
                                ✅ Votre projet a aussi été enregistré automatiquement !
                            </p>
                        )}

                        {projectSuccess === false && (
                            <p className="warning-text">
                                ⚠️ Votre compte est créé, mais une erreur est survenue lors de l’enregistrement du projet.<br />
                                Vous pourrez le créer manuellement après connexion.
                            </p>
                        )}

                        <div className="inscriptionClientModal-actions">
                            <button type="button" onClick={() => onClose()}>FERMER</button>
                            <button type="button" onClick={() => onSwitch("connexion")}>ME CONNECTER</button>
                        </div>
                    </div>
                )}


            </div>
        </div>
    );
}
